import Players from "./players";

export default Players;
